@use "variables" as *;

.itemDiv {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title {
  font-size: $fontSize-m;
  flex-grow: 0 !important;
  flex-shrink: 1;
  height: 20px;
}

.chipsCard {
  display: flex;
  flex-wrap: wrap;
  padding-left: $spacing-s;
  padding-right: $spacing-s;
  min-height: 40px;
}

.chipBox {
  display: flex;
  flex-wrap: wrap;
  margin-right: $spacing-xs;
  margin-top: $spacing-xs;
  margin-bottom: $spacing-xs;
  max-width: 100%;
}

.chip {
  font-size: $fontSize-s !important;
}

.addChip {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
}

.addButton {
  margin: 0 $spacing-xs;
}

.loadingIndicator {
  width: 18px !important;
  height: 18px !important;
}
